import { render, staticRenderFns } from "./PreviewKYC.vue?vue&type=template&id=72a76d46&"
import script from "./PreviewKYC.vue?vue&type=script&lang=js&"
export * from "./PreviewKYC.vue?vue&type=script&lang=js&"
import style0 from "./PreviewKYC.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports